import {Modal, Text, ViewPager} from "@ui-kitten/components";
import {ImageBackground, View} from "react-native";
import {TouchableWithoutFeedback} from "react-native-gesture-handler";
import {WecyclePresentation} from "./slides/wecycle-presentation";
import {PickupRequestExplain} from "./slides/pickup-request-explain";
import {FlexibilityExplain} from "./slides/flexibility-explain";
import {PricingExplain} from "./slides/pricing-explain";
import {DotSlider} from "./dot-slider";
import * as React from "react";
import AsyncStorage from "@react-native-async-storage/async-storage";
import {LinearGradient} from "expo-linear-gradient";

export function WelcomeSlider() {
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const [showWelcome, setShowWelcome] = React.useState(false)

    React.useEffect(() => {
        AsyncStorage.getItem('@welcome').then(result => {
            setShowWelcome(result !== 'hide')
        })
    }, [])

    const hideWelcome = async () => {
        setShowWelcome(false)
        await AsyncStorage.setItem('@welcome', 'hide')
    }

    return <Modal visible={showWelcome} style={{
        backgroundColor: "#405066",
        flex: 1,
        bottom: 0,
        top: 0,
        left: 0,
        right: 0
    }}>

        <LinearGradient style={{height: '100%', flex: 1 }} colors={['#77af50', '#77af50','#116d6a','#116d6a', '#116d6a', '#116d6a', '#163b52']}>
            <ImageBackground style={{
                height: '100%',
                width: '100%',
                resizeMode: "cover",
                justifyContent: "center"
            }} source={require('../../../assets/images/layout/feuilles.png')}>

                <View style={{alignItems: "flex-end", paddingRight: 30}}>
                    <TouchableWithoutFeedback onPress={hideWelcome}>
                        <Text style={{color: "white"}}>Skip</Text>
                    </TouchableWithoutFeedback>
                </View>

                <ViewPager selectedIndex={selectedIndex} onSelect={setSelectedIndex}
                           style={{alignItems: "center", justifyContent: "center"}}>
                    <WecyclePresentation />
                    <PickupRequestExplain />
                    <PricingExplain />
                    <FlexibilityExplain onSkip={hideWelcome}/>
                </ViewPager>

                <View style={{flexDirection: "row"}}>
                    <View style={{flex: 2, alignItems: "center", justifyContent: "center"}}>
                        <TouchableWithoutFeedback onPress={() => setSelectedIndex(selectedIndex-1)}>
                            {selectedIndex > 0 && <Text style={{color: "white", fontWeight: "bold", padding: 10}}>Prev.</Text>}
                        </TouchableWithoutFeedback>
                    </View>
                    <View style={{flex: 1, flexDirection: "row", alignItems: "center", justifyContent: "space-around"}}>
                        <DotSlider currentIndex={selectedIndex} index={0} changePane={setSelectedIndex}/>
                        <DotSlider currentIndex={selectedIndex} index={1} changePane={setSelectedIndex}/>
                        <DotSlider currentIndex={selectedIndex} index={2} changePane={setSelectedIndex}/>
                        <DotSlider currentIndex={selectedIndex} index={3} changePane={setSelectedIndex}/>
                    </View>
                    <View style={{flex: 2, alignItems: "center", justifyContent: "center"}}>
                        <TouchableWithoutFeedback onPress={() => setSelectedIndex(selectedIndex+1)}>
                            {selectedIndex < 3 && <Text style={{color: "white", fontWeight: "bold", padding: 10}}>Next</Text>}
                        </TouchableWithoutFeedback>
                    </View>
                </View>
            </ImageBackground>
        </LinearGradient>
    </Modal>
}